import React, { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DATE_STYLES, getPickerFormat } from 'utils/dateFormats';

const pickerStyle = ({ showTimeSelectOnly, showTimeSelect, showTimeInput }) => {
    if (showTimeSelectOnly) return DATE_STYLES.TIME;
    if (showTimeSelect || showTimeInput) return DATE_STYLES.DATE_TIME;
    return DATE_STYLES.DATE;
};

/**
 * The only place the app renders react-datepicker — import this, never
 * react-datepicker directly. Its `dateFormat` drives both what the text field shows and how
 * typed input is parsed, so it — and the time list's `timeFormat` — always come
 * from the account's display format. Call sites can't override them.
 *
 * Accepts every other react-datepicker prop.
 */
const AppDatePicker = forwardRef(({ dateFormat, timeFormat, ...props }, ref) => (
    <ReactDatePicker
        {...props}
        ref={ref}
        dateFormat={getPickerFormat(pickerStyle(props))}
        timeFormat={getPickerFormat(DATE_STYLES.TIME)}
    />
));

export default AppDatePicker;
